// @flow

import styled from 'styled-components';

export const RadioButton = styled.input.attrs({ type: 'radio' })`
  cursor: pointer;
`;
